var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppareil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.06,
    viewBox: "0 0 85 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.933 46.933h55.467c3.529 0 6.4-2.871 6.4-6.4v-34.133c0-3.529-2.871-6.4-6.4-6.4h-55.467c-3.529 0-6.4 2.871-6.4 6.4v34.133c0 3.529 2.871 6.4 6.4 6.4zM12.8 6.4c0-1.178 0.956-2.133 2.133-2.133h55.467c1.178 0 2.133 0.956 2.133 2.133v34.133c0 1.178-0.956 2.133-2.133 2.133h-55.467c-1.178 0-2.133-0.956-2.133-2.133v-34.133z",
    fill: "#095797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2 51.2h-81.067c-1.178 0-2.133 0.956-2.133 2.133v4.267c0 3.529 2.871 6.4 6.4 6.4h72.533c3.529 0 6.4-2.871 6.4-6.4v-4.267c0-1.178-0.956-2.133-2.133-2.133zM78.933 59.733h-72.533c-1.178 0-2.133-0.956-2.133-2.133v-2.133h76.8v2.133c0 1.178-0.956 2.133-2.133 2.133z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppareil);
export default __webpack_public_path__ + "static/media/appareil.e41610389715c6723c21a0f0bf6b90c6.svg";
export { ForwardRef as ReactComponent };